import React from "react";
import { Box, ThemeProvider, useTheme } from "@mui/material";
import AnimatedHero from "../../components/animated_hero";

export default function HomeHeroSection() {
  const theme = useTheme();

  const lines = [
    "Powering Industrial",
    "Growth with",
    "Reliable Hydraulics",
    "and Automation",
  ];

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        <AnimatedHero
          videoSrc="/assets/videos/homebackground.mp4"
          lines={lines}
        />
      </Box>
    </ThemeProvider>
  );
}
